var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center m-t-40"},[_vm._t("icon"),_vm._t("text")],2),_c('div',{staticClass:"column col-12 col-lg-12 m-t-40"},[_c('div',{staticClass:"bottom-message"},[_vm._t("bottom")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }